import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import ProgressBar from 'react-bootstrap/ProgressBar';
//import { disconnect, connect, sendScript, sendPaste } from './WebSerialUtils';
import { disconnect, connect, sendScript } from './WebSerialUtils';
import {
  //blinkCode,
  unzipUhadabotCode,
  //gcCollectCode,
  //cleanCode,
  confirmUhadabotFolderCode,
} from '../utils/SetupESP32Stubs';

const encoder = new TextEncoder();
let port = null;
let writer = null;
let reader = null;

function UploadFileBundleCard(props) {
  const stepStates = {
    init: 'init',
    uploadingConfig: 'uploadingConfig',
    doneUploadingConfig: 'doneUploadingConfig',
  };

  const [connected, setConnected] = useState(false);
  const [uhadabotBundleFile, setUhadabotBundleFile] = useState(null);
  const [uploadingProgress, setUploadingProgress] = useState(-1);
  const [wifiSsid, setWifiSsid] = useState('');
  const [wifiPwd, setWifiPwd] = useState('');
  const [ipAddr0, setIpAddr0] = useState('');
  const [ipAddr1, setIpAddr1] = useState('');
  const [ipAddr2, setIpAddr2] = useState('');
  const [ipAddr3, setIpAddr3] = useState('');
  const setIpAddr = [setIpAddr0, setIpAddr1, setIpAddr2, setIpAddr3];
  const [errorMsg, setErrorMsg] = useState(null);
  const [showNetworkConfig, setShowNetworkConfig] = useState(false);
  const [whichStep, setWhichStep] = useState(stepStates.init);
  const [networkAsAP, setNetworkAsAP] = useState(false);

  async function uploadNetworkConfigMoveBootPy() {
    // Connect then upload
    connect(port, writer, reader).then(([p, w, r]) => {
      port = p;
      writer = w;
      reader = r;
      setConnected(true);

      // Set step state
      setWhichStep(stepStates.uploadingConfig);

      const ipAddr = `${ipAddr0}.${ipAddr1}.${ipAddr2}.${ipAddr3}`;
      let config = `{\\n
    "ros2_web_bridge_ip_addr": "${ipAddr}",\\n
    "network": {\\n
        "ssid": "${wifiSsid.trim()}",\\n
        "password": "${wifiPwd.trim()}"\\n
    }\\n
}`;

      if (networkAsAP === true) {
        config = `{\\n
    "ros2_web_bridge_ip_addr": "192.168.86.2",\\n
    "network": {\\n
        "ssid": "${wifiSsid.trim()}",\\n
        "password": "${wifiPwd.trim()}"\\n
        "as_ap": true\\n
    }\\n
}`;
      }

      // Send a couple of ctrl-c's
      writer.write(Uint8Array.from([0x03]));
      writer.write(Uint8Array.from([0x03]));
      writer.write(encoder.encode(`import os; os.remove("hb.json")\r\n`));
      writer.write(encoder.encode(`f = open('uhadabot/hb.json', 'w')\r\n`));
      writer.write(encoder.encode(`f.write('${config}')\r\n`));
      writer.write(encoder.encode(`f.close()\r\n`));

      setTimeout(() => {
        // Command to move uhadabot's boot.py
        writer.write(
          encoder.encode(
            `import os; os.rename("/uhadabot/boot.py", "/boot.py")\r\n`
          )
        );
        writer.write(encoder.encode(`import os; os.listdir()\r\n`));

        // Wait hack for code to run, file to flush
        setTimeout(() => {
          disconnect(port, writer, reader);
          port = null;
          writer = null;
          reader = null;
          // Set step state
          setWhichStep(stepStates.doneUploadingConfig);
          setConnected(false);
        }, 2000);
      }, 2000);
    });
  }

  function uploadHbzFile() {
    // Connect then upload
    connect(port, writer, reader)
      .then(([p, w, r]) => {
        const bufSize = 16;
        port = p;
        writer = w;
        reader = r;
        setConnected(true);

        const filePromise = uhadabotBundleFile.arrayBuffer();
        filePromise
          .then((buffer) => {
            // The buffer is ready
            let uint8Arr = new Uint8Array(buffer);

            // The following allows the writes for the file contents to write out
            // asyncronously so the writer has a chance to flush and the reader
            // has a chance to readLoop. It is a recursive function to create
            // Promises to write out the chunks.
            const createWritePromise = (startIdx, stopIdx) => {
              const writeOutSubSlice = new Promise((resolve, reject) => {
                setTimeout(() => {
                  let cmd = 'f.write(bytes([';
                  let subslice = uint8Arr.slice(startIdx, stopIdx);
                  subslice.forEach((charCode) => {
                    cmd += `${charCode},`;
                  });
                  cmd += ']))\n';
                  writer.write(encoder.encode(`${cmd}\r\n`));
                  resolve(stopIdx);
                }, 50);
              });
              writeOutSubSlice.then((newStartIdx) => {
                const prog = Math.floor(
                  (newStartIdx / (uint8Arr.length + 10)) * 100
                );
                if (newStartIdx < 10 || newStartIdx % 10 === 0) {
                  // Update progress
                  setUploadingProgress(prog);
                }

                if (newStartIdx === uint8Arr.length) {
                  // Wrote last char code, close the stream
                  writer.write(encoder.encode('f.close()\r\n'));

                  // Soft reset
                  writer.write(Uint8Array.from([0x04]));

                  new Promise(() => {
                    // Wait a bit for the file system to flush
                    setTimeout(() => {
                      // .. before unzip untar on ESP32
                      sendScript(unzipUhadabotCode.code, writer).then(() => {
                        new Promise(() => {
                          // A bit of a hack - wait a bit for the ESP32 to run
                          // the script
                          setTimeout(() => {
                            // Mark 99% done
                            setUploadingProgress(99);

                            // Verify upload
                            sendScript(
                              confirmUhadabotFolderCode.code,
                              writer
                            ).then(() => {
                              // Mark 100% done
                              setUploadingProgress(100);

                              // Show network config
                              setShowNetworkConfig(true);

                              // Hack wait for script again
                              setTimeout(() => {
                                // Disconnect from serial port
                                disconnect(port, writer, reader);
                                port = null;
                                writer = null;
                                reader = null;
                                setConnected(false);
                              }, 2000);
                            });
                          }, 10000);
                        });
                      });
                    }, 1000);
                  });
                } else {
                  // RECURSION!
                  // Create another promise to write out next chunk
                  createWritePromise(
                    newStartIdx,
                    Math.min(newStartIdx + bufSize, uint8Arr.length)
                  );
                }
              });
            };

            // Start progress
            setUploadingProgress(0);

            // Write first command's - start w a couple of ctrl-c's
            writer.write(Uint8Array.from([0x03]));
            writer.write(Uint8Array.from([0x03]));
            writer.write(
              encoder.encode(
                `import os; os.remove("/boot.py"); os.remove("/main.py")\r\n`
              )
            );

            // Soft reset
            writer.write(Uint8Array.from([0x04]));

            writer.write(
              encoder.encode(`f = open('${uhadabotBundleFile.name}', 'wb')\r\n`)
            );

            // Kick off recursion by writing out the first buf size chunk
            createWritePromise(0, Math.min(bufSize, uint8Arr.length));
          })
          .finally(() => {});
      })
      .catch((ex) => {
        disconnect(port, writer, reader);
        setErrorMsg(ex.message);
        setConnected(false);
      });
  }

  let uploadComponent = '';
  if (uhadabotBundleFile !== null) {
    let uploadCta = (
      <Col xs="12" className="pt-3 pb-2">
        <Button
          block
          variant="primary"
          onClick={() => {
            uploadHbzFile();
          }}
        >
          Upload to the ESP32
        </Button>
        <div className="text-center">
          <small>
            * Upon clicking the Upload button, please select the serial port
            your ESP32 is connected to.
          </small>
        </div>
      </Col>
    );
    if (uploadingProgress >= 0) {
      let progressLabel =
        uploadingProgress < 100
          ? `Uploading... (${uploadingProgress}%)`
          : 'Done!';
      progressLabel =
        uploadingProgress === 99
          ? 'Almost done... 10-15 secs more (99%)'
          : progressLabel;
      uploadCta = (
        <Col xs="12" className="pt-3 pb-2">
          <p>
            Upon completion, if the upload succeeds, your ESP32's on-board LED
            should blink a couple of times, then remain lit.
          </p>
          <p>
            If the upload *failed*, the LED will blink very rapidly, then will
            turn off. If that happens, press the "EN" button on the ESP32,
            refresh this page and try again.
          </p>
          <ProgressBar now={uploadingProgress} label={progressLabel} />
        </Col>
      );
    }
    uploadComponent = <Row className="pt-2">{uploadCta}</Row>;
  }

  function ipAddrCb(ipIdx, val) {
    const nval = Number.parseInt(val);
    const invalidVal = (isNaN(nval) && val !== '') || val < 0 || val > 255;
    if (invalidVal === false) {
      setIpAddr[ipIdx](isNaN(nval) ? '' : nval.toString());
    }
  }

  let errorComponent = '';
  if (errorMsg !== null) {
    errorComponent = <p className="py-2 text-danger">Error: {errorMsg}</p>;
  }

  let configListItemComponent = (
    <ListGroup.Item>
      <Row className="pt-2 text-center">
        <Col xs="12">
          <small
            className="text-primary"
            onClick={(ev) => {
              ev.preventDefault();
              setShowNetworkConfig(true);
            }}
          >
            <u>
              Click to skip the file bundle upload. Just want to configure the
              ESP32's ROS 2 network settings.
            </u>
          </small>
        </Col>
      </Row>
    </ListGroup.Item>
  );
  if (showNetworkConfig) {
    let uploadConfigButtonDisable =
      ipAddr0 === '' ||
      ipAddr1 === '' ||
      ipAddr2 === '' ||
      ipAddr3 === '' ||
      wifiSsid === '' ||
      wifiPwd === '';
    if (networkAsAP === true) {
      uploadConfigButtonDisable =
        wifiSsid === '' || wifiPwd === '' || wifiPwd.length < 10;
    }
    let ipAddrComponent = [];
    [ipAddr0, ipAddr1, ipAddr2, ipAddr3].forEach((ipAddr, idx) => {
      ipAddrComponent.push(
        <Col key={`ipAddrCol${idx}`} xs="3" md="2">
          <Form.Control
            key={`ipAddrFormCtrl${idx}`}
            type="text"
            aria-describedby={`ipAddrHelpBlock${idx}`}
            value={ipAddr}
            onChange={(ev) => {
              ipAddrCb(idx, ev.target.value.trim());
            }}
          />
        </Col>
      );
    });

    let uploadConfigCtaComponent = (
      <div>
        <Button
          block
          variant="primary"
          onClick={() => {
            uploadNetworkConfigMoveBootPy();
          }}
          disabled={uploadConfigButtonDisable}
        >
          Upload network configuration to the ESP32
        </Button>
        <div className="text-center">
          <small>
            * Upon clicking the Upload button, please select the serial port
            your ESP32 is connected to.
          </small>
        </div>

        <Row className="pt-4">
          <Col xs="12">
            <Form.Check
              label="(Experimental) Wait... I cannot connect the ESP32 to my network (since I have to get IT approval). Let's set up my ESP32 as an access point so I can just connect to it directly as a WiFi router."
              onClick={() => {
                setNetworkAsAP(networkAsAP === true ? false : true);
              }}
            />
          </Col>
        </Row>
      </div>
    );
    if (whichStep === 'uploadingConfig') {
      uploadConfigCtaComponent = (
        <div className="text-center">Uploading... be patient.</div>
      );
    } else if (whichStep === 'doneUploadingConfig') {
      uploadConfigCtaComponent = (
        <div className="text-center">
          <p>Done. Press the "EN" button on the ESP32.</p>
          <p>
            After pressing / releasing the "EN" button, if all's working, you
            should see the ESP32's LED start to blink while it's connecting to
            the network and ROS 2 system, then stay lit when connection is
            successful.
          </p>
          <p>
            Something went wrong if: (1) The LED continues to blink forever. (2)
            After blinking, the LED turns off... then refresh this page and try
            again.
          </p>
        </div>
      );
    }

    if (networkAsAP === false) {
      configListItemComponent = (
        <ListGroup.Item className="pt-4">
          <p>
            Enter parameters to configure the network settings on the ESP32:
            <br />
            <small>
              NOTE: the ESP32 can only connect to 2.4 GHz WiFi networks.
            </small>
          </p>
          <Form>
            <Form.Group as={Row}>
              <Form.Label column xs="12" md="2">
                Your 2.4 GHz WiFi Network SSID
              </Form.Label>
              <Col xs="12" md="10">
                <Form.Control
                  type="text"
                  value={wifiSsid}
                  onChange={(ev) => {
                    setWifiSsid(ev.target.value);
                  }}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column xs="12" md="2">
                Your WiFi Network Password
              </Form.Label>
              <Col xs="12" md="10">
                <Form.Control
                  type="text"
                  value={wifiPwd}
                  onChange={(ev) => {
                    setWifiPwd(ev.target.value);
                  }}
                />
                <Form.Text id="wifi_pwd" muted>
                  To allow the ESP32 to connect to your network.
                </Form.Text>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column xs="12" md="2">
                Your Computer's IP Address
              </Form.Label>

              {ipAddrComponent}

              <Col xs="12" md={{ span: 10, offset: 2 }}>
                <Form.Text id="ipAddrHelpBlock0" muted>
                  To allow the ESP32 to connect to the ROS 2 system running
                  within your computer's Hadabot Docker container stack.
                </Form.Text>
              </Col>
            </Form.Group>
          </Form>
          {uploadConfigCtaComponent}
        </ListGroup.Item>
      );
    } else {
      // Set up network as AP
      configListItemComponent = (
        <ListGroup.Item className="pt-4">
          <p>
            Enter parameters to set up the ESP32 as an access point (ie a
            separate WiFi AP router for your laptop to connect to):
          </p>
          <Form>
            <Form.Group as={Row}>
              <Form.Label column xs="12" md="2">
                ESP32 AP Network SSID
              </Form.Label>
              <Col xs="12" md="10">
                <Form.Control
                  type="text"
                  value={wifiSsid}
                  onChange={(ev) => {
                    setWifiSsid(ev.target.value);
                  }}
                />
                <Form.Text id="wifi_ssid" muted>
                  This is the WiFi your laptop (running the Hadabot software
                  stack) will eventually connect to.
                </Form.Text>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column xs="12" md="2">
                ESP32 AP WiFi Password
              </Form.Label>
              <Col xs="12" md="10">
                <Form.Control
                  type="text"
                  value={wifiPwd}
                  onChange={(ev) => {
                    setWifiPwd(ev.target.value);
                  }}
                />
                <Form.Text id="wifi_pwd" muted>
                  The password for the ESP32 WiFi AP SSID. Has to be 10 letters
                  or more.
                </Form.Text>
              </Col>
            </Form.Group>
          </Form>
          {uploadConfigCtaComponent}
        </ListGroup.Item>
      );
    }
  }

  return (
    <Row className="pt-3">
      <Col xs={12} sm={12} md={12} lg={12} className="text-left">
        <Card className="border-primary">
          <Card.Header className="bg-primary text-white">
            Upload the Hadabot ESP32 File Bundle
          </Card.Header>
          <Card.Body className="text-dark">
            <ListGroup as="ul" variant="flush">
              <ListGroup.Item className="pb-4">
                <Form.File id="formcheck-api-regular">
                  <Form.File.Label>
                    Select the Hadabot{' '}
                    <span className="text-primary">uhadabot.hbz</span> file
                    bundle, then upload to the ESP32:
                  </Form.File.Label>
                  <Form.File.Input
                    accept=".hbz"
                    onChange={(e) => {
                      console.log(e.target.files);
                      setUhadabotBundleFile(e.target.files[0]);
                    }}
                  />
                </Form.File>
                {uploadComponent}
              </ListGroup.Item>

              {configListItemComponent}
            </ListGroup>
            {errorComponent}
          </Card.Body>
        </Card>
      </Col>

      {/*
      <Col xs={12} className="py-5"></Col>
      <Col xs={12} sm={12} md={12} lg={12}>
        <input
          type="file"
          accept=".zlib"
          onChange={(e) => {
            console.log(e.target.files);
            setUhadabotBundleFile(e.target.files[0]);
          }}
        />
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            connect(port, writer, reader)
              .then(([p, w, r]) => {
                port = p;
                writer = w;
                reader = r;
                setConnected(true);
              })
              .catch((ex) => {
                setErrorMsg(ex.message);
              });
          }}
        >
          Connect
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            connect(port, writer, reader).then(([p, w, r]) => {
              port = p;
              writer = w;
              reader = r;
              setConnected(true);
              sendScript(confirmUhadabotFolderCode.code, writer)
                //writer
                //  .write(encoder.encode('import os; os.listdir()' + '\r\n'))
                .then(() => {
                  disconnect(port, writer, reader);
                  port = null;
                  writer = null;
                  reader = null;
                  setConnected(false);
                });
            });
          }}
        >
          Verify uhadabot folder
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            sendScript(blinkCode.code, writer);
          }}
        >
          Send blink code
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            sendScript(cleanCode.code, writer);
          }}
        >
          Send CLEAN code
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            sendScript(gcCollectCode.code, writer);
          }}
        >
          Send gc collect
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            sendScript(unzipUhadabotCode.code, writer);
          }}
        >
          Send unzip commands
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            writer.write(encoder.encode('\r\n'));
            writer.write(encoder.encode('\r\n'));
          }}
        >
          Send enter enter
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            writer.write(encoder.encode('import os; os.listdir()' + '\r\n'));
          }}
        >
          Send os.listdir() command
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            writer.write(Uint8Array.from([0x01]));
          }}
        >
          Enter RAW
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            writer.write(Uint8Array.from([0x05]));
          }}
        >
          Enter PASTE
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            writer.write(Uint8Array.from([0x02]));
          }}
        >
          Enter Normal REPL
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            writer.write(Uint8Array.from([0x04]));
          }}
        >
          Reset - CTRL-D
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="primary"
          onClick={() => {
            disconnect(port, writer, reader)
              .then(() => {
                port = null;
                writer = null;
                reader = null;
                setConnected(false);
              })
              .catch((ex) => {
                setErrorMsg(ex.message);
              });
          }}
        >
          Disconnect
        </Button>
      </Col>

      <Col xs={12} sm={12} md={12} lg={12}>
        <h1>Connected: {connected.toString()}</h1>
      </Col>
      */}
    </Row>
  );
}

export default UploadFileBundleCard;
